var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient-image",style:('width:' + _vm.width + 'rem; height: ' + _vm.height + 'rem; border-radius: ' + _vm.radius + 'px; background:' + (_vm.url ? 'url(' + _vm.url + ')' : _vm.gradient))})}
var staticRenderFns = []

export { render, staticRenderFns }